export default class BulkAdd {

  private readonly input: JQuery;
  private readonly button: JQuery;
  private readonly inputFormatErrorMessage: string;
  private readonly inputLengthErrorMessage: string;
  private readonly productsAddedMessage: string;

  constructor(private container: JQuery) {
    this.input = container.find('.js-bulkAddInput');
    this.button = container.find('.js-bulkAddButton');
    this.inputFormatErrorMessage = container.data('inputFormatError');
    this.inputLengthErrorMessage = container.data('inputLengthError');
    this.productsAddedMessage = container.data('productsAddedMessage');
  }

  getValue(): string {
    return this.input.val() as string || '';
  }

  setValue(value = '') {
    this.input.val(value);
    if (value.length) {
      this.showFormatError();
    }
  }

  getValueLineCount(): number {
    const value = this.getValue();
    return (value.match(/^\s*\S/gm) || '').length;
  }

  getButton(): JQuery {
    return this.button;
  }

  showFormatError() {
    window.NotificationHelper.showError(this.inputFormatErrorMessage);
  }

  showLengthError() {
    window.NotificationHelper.showError(this.inputLengthErrorMessage);
  }

  showProductsAddedInfo() {
    window.NotificationHelper.showConfirmation(this.productsAddedMessage);
  }
}
